import { Field } from 'formik'
import sortCinemas from '../../../../functions/sortCinemas'
import WrapperAccordion from '../../../general/WrapperAccordion'
import MultiselectCheckboxMovieExtension from '../MultiselectCheckboxMovieExtension'
import Button from '../../../general/Button'
import getMovieExtensions from '../../../../functions/getMovieExtensions'

const AttributesAccordion = ({
    values, 
    activeTabClass, 
    setActiveTab, 
    title, 
    classes, 
    cliCinemas, 
    clientCinemaId, 
    setFieldValue
}) => {
    const {cliMovieRelevantSourceMovies, movieExtensionsItems, movieExtensionsReset, attributes, movie} = values
    const cinemasRelevantForMovie = movie.cinemaIds
    const movieExtension = {}
    const cinemaKeysSorted = sortCinemas(clientCinemaId, cliCinemas)

    const onReset = movieExtensionPK => {
        setFieldValue('movieExtensionsReset', [...movieExtensionsReset, movieExtensionPK])
    }

    return (
        <WrapperAccordion
            title={title}
            className={classes}
            selectionActiveClass={activeTabClass}
            collapseActiveSelection={setActiveTab}
            gapless={true}
        >
            {cinemaKeysSorted.map(cinemaId => {
                if(('global' === cinemaId || !_.contains(cinemasRelevantForMovie, cinemaId)) && cinemasRelevantForMovie.length !== 0) {
                    return ''
                }

                getMovieExtensions(cinemaId, movieExtension, movieExtensionsItems, cliMovieRelevantSourceMovies)
                const currentCinema = _.findWhere(cliCinemas, {pk: cinemaId})

                if(!movieExtension[cinemaId]) {
                    return ''
                }

                const movieExtensionPK = movieExtension[cinemaId].pk
                const isReset = movieExtensionsReset.includes(movieExtensionPK)
                return (
                    <fieldset key={cinemaId} className={"field-category field-genres" + (isReset ? ' field-reset' : '')}>
                        <legend className="text-small-light">{currentCinema.nameDisplay}</legend>

                        <div className="grid-container">
                            {Object.keys(attributes[cinemaId].technical).map(attrId => (
                                <div key={'field' + attrId} className="field-checkbox">
                                    <Field
                                        key={attrId} 
                                        type="attributes"
                                        attrid={attrId}
                                        attributes={attributes}
                                        movieid={movie.id}
                                        cinemaid={cinemaId}
                                        movieextension={movieExtension[cinemaId]}
                                        name={"attributes." + cinemaId + ".technical." + attrId} 
                                        component={MultiselectCheckboxMovieExtension} 
                                        disabled={isReset}
                                        value={attributes[cinemaId].technical[attrId]} 
                                    />
                                </div>
                            ))}
                        </div>

                        {isReset ? (
                            <div className="reset-button text text-small-light">Zum Reset vorgemerkt</div>
                        ) : (
                            <Button 
                                className="reset-button"
                                spanClassName="text-small-light"
                                text="Reset"
                                hideText={false}
                                disabled={isReset}
                                onClick={() => onReset(movieExtensionPK)}
                            />
                        )}
                </fieldset>
            )})}
          
        </WrapperAccordion>
    )
}

export default AttributesAccordion